const categoriesData = [
  {
    id: 1,
    title: "Outerwear",
    image: require("./../assets/categoriesImgs/outerwear.png"),
  },
  {
    id: 2,
    title: "T-shirts and tops",
    image: require("./../assets/categoriesImgs/tshirts.png"),
  },
  {
    id: 3,
    title: "Sweaters and cardigans",
    image: require("./../assets/categoriesImgs/sweater.png"),
  },
  {
    id: 4,
    title: "Dresses",
    image: require("./../assets/categoriesImgs/dress.png"),
  },
  {
    id: 5,
    title: "Pants",
    image: require("./../assets/categoriesImgs/pants.png"),
  },
  {
    id: 6,
    title: "Sportswear",
    image: require("./../assets/categoriesImgs/sportwear.png"),
  },
];

export default categoriesData;
